/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import LazyLoad from 'react-lazyload';

interface Props {
  src: string;
  threshold?: number | number[];
  title?: string | null;
}

const VisibleVideo = ({ src, threshold = 0.5, title }: Props) => {
  const [ref, inView, entry] = useInView({
    threshold: threshold
  });
  const video = entry?.target as HTMLMediaElement;

  useEffect(() => {
    if (inView) {
      video.play();
    } else if (video) {
      video.pause();
    }
  }, [inView, video]);

  return (
    <LazyLoad offset={100}>
      <video
        ref={ref}
        src={src}
        title={title || ''}
        style={{
          width: '100%',
          boxShadow: '0px -4px 8px rgba(40, 44, 51, 0.15)'
        }}
      />
    </LazyLoad>
  );
};

export default VisibleVideo;
